export enum ExportInfoStatusDto {
  Shared = 'Shared',
  Imported = 'Imported',
  Recalled = 'Recalled',
  ImportDisabled = 'ImportDisabled',
}
